import config from '@/core/config/config';
import { UPDATE_USER } from '@/graphql/mutations/pii/updateUser';
import { customFetcher, getGqlString } from '@/utils/customFetcher';
import { mutationConfig, swrConfig } from '@/utils/swrConfig';
import useSWRMutation from 'swr/mutation';

// TODO: Using native fetch here as graphql-request does not support cookies. Consider updating if support is added in the future.
const updateUserFetcher = async (
  gqlDocument: any,
  {
    arg,
  }: {
    arg: {
      userId: string;
      user: {
        phoneNumber: string;
      };
    };
  },
) => {
  return customFetcher(config.PII_SERVER, {
    query: getGqlString(gqlDocument),
    variables: { ...arg },
  });
};

export const useUpdateUser = () => {
  return useSWRMutation(UPDATE_USER, updateUserFetcher, mutationConfig);
};
